const DEFAULT_SAFE_FILE_NAME = 'file';

const INVALID_FILE_NAME_CHARS = /[<>:"/\\|?*\x00-\x1f\x7f]/g;

export function sanitiseFileName(rawName: string): string {
  let name = rawName
    .replace(INVALID_FILE_NAME_CHARS, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[. ]+$/, '');

  if (!name || name === '.' || name === '..') {
    return DEFAULT_SAFE_FILE_NAME;
  }

  return name;
}
